"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class IsMobilePhoneValidator {
    constructor(locale) {
        this.locale = locale;
    }
    isValid(input) {
        if (input) {
            return validatorJS.isMobilePhone(input, this.locale);
        }
        return false;
    }
}
exports.IsMobilePhoneValidator = IsMobilePhoneValidator;
//# sourceMappingURL=IsMobilePhoneValidator.js.map